import { render, staticRenderFns } from "./AmsTableExample.vue?vue&type=template&id=d3b00d82&"
import script from "./AmsTableExample.vue?vue&type=script&lang=js&"
export * from "./AmsTableExample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports